import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=77014f24&"
import script from "./AlertCard.vue?vue&type=script&lang=js&"
export * from "./AlertCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77014f24')) {
      api.createRecord('77014f24', component.options)
    } else {
      api.reload('77014f24', component.options)
    }
    module.hot.accept("./AlertCard.vue?vue&type=template&id=77014f24&", function () {
      api.rerender('77014f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alerts/AlertCard.vue"
export default component.exports